// extracted by mini-css-extract-plugin
module.exports = {"child":"ProducersSizesTable_style_child__24I7-","child_expanded":"ProducersSizesTable_style_child_expanded__XW_KS"};